export default {
    index:{
        pageTitle:'USB自定义键盘配置工具',
        loopInterval:'循环间隔',
        helpTitle:'帮助',
        helpTips0:'5种按键模式介绍:',
        helpTips1:'1.普通键:将3键键盘某一按键按键定义为如1、2、3、a、b、c、?、空格等可输入的普通按键',
        helpTips1_1:'注意:普通键如果输入大写字母或!@#$%等按键 实际是通过Shift+对应按键触发!',
        helpTips2:'2.功能键:将3键键盘某一按键按键定义为Ctrl、Alt、Win、Command、回车等功能按键',
        helpTips2_1:'F13-F24为特殊功能按键,普通键盘并没有,可以作为软件内的自定义快捷键,防冲突使用!',
        helpTips3:'3.多媒体键:将3键键盘某一按键按键定义为音量加、亮度加、打开浏览器等多媒体按键',
        helpTips4:'4.组合键:将3键键盘某一按键按键定义为2键-5键组合,如一键Ctrl+c、一键Win+l、一键Ctrl+Alt+Delete等组合按键',
        helpTips5:'5.字符串:将3键键盘某一按键按键定义为输入字符串,如一键输入用户名、一键输入select * from等',
        helpTips6:'6.鼠标:将3键键盘某一按键按键定义为鼠标按键点击、鼠标移动、滚轮滑动等',
        helpButton:'查看帮助',
        troubleshootTitle:'键盘插上没反应？逐项排查',
        troubleshoot1:'浏览器',
        troubleshoot1_desc:'必须用 Chrome 或 Edge（103 版本以上），通过 https 或 localhost 访问；Safari、Firefox 不支持串口，无法连接。',
        troubleshoot2:'访问方式',
        troubleshoot2_desc:'不要直接双击网页文件打开（file:// 无法使用串口），请通过网址访问。',
        troubleshoot3:'点“连接”没弹出选择窗口',
        troubleshoot3_desc:'多为 USB线问题——换一条数据线（有的线只充电不传数据）、换一个USB口，尽量直插主机不用扩展坞。',
        troubleshoot4:'弹窗里找不到设备',
        troubleshoot4_desc:'确认系统已识别到串口设备（VID 0x1209 / PID 0xC550），重新插拔键盘后再试。',
        troubleshoot5:'端口被占用、连接失败',
        troubleshoot5_desc:'关闭可能占用串口的程序（串口助手、Arduino IDE、其他烧录/改键工具）后重试。',
        troubleshoot6:'连接成功但读不到配置/提示固件过旧',
        troubleshoot6_desc:'按提示更新固件后再配置。',
        troubleshoot7:'多次插拔后异常',
        troubleshoot7_desc:'刷新页面（F5），重新插拔键盘后再连接。',
        windowsTipsTitle:'Windows / 公司电脑提示',
        windowsTips1:'右下角提示“无法识别的 USB 设备”时，说明Windows在读取设备信息时失败，不是网页配置或浏览器设置的问题；请先换直插USB口、换一条确认能传数据的线，并在另一台电脑测试。',
        windowsTips2:'若只有公司电脑无法识别、其他电脑正常，请联系公司IT检查 USB外设管控或白名单；请勿禁用USB Root Hub、USB控制器等系统设备。',
        windowsTips3:'设备管理器出现“未知 USB 设备”时，可右键选择“卸载设备”后重新插拔；如出现“删除此设备的驱动程序”选项，不要勾选。',
        windowsTips4:'提交配置后，建议重新插拔键盘，再用“在线键盘测试”确认按键已经按预期生效。',
        macTipsTitle:'Mac 用户配置注意事项',
        macTips1:'浏览器',
        macTips1_desc:'用Mac版 Chrome 或 Edge（103 以上），Safari 不支持串口连接。',
        macTips2:'修饰键对应',
        macTips2_desc:'Mac的 Command（⌘）与Windows的 Win 是同一个键码，配置时选“左Win/Command”即可。',
        macTips3:'复制粘贴',
        macTips3_desc:'Windows是 Ctrl+C/V，Mac是 Command+C/V（组合键里把修饰键选成“左Win/Command” + c/v；“常用组合键”里也有Mac版可直接套用）。',
        macTips4:'锁屏',
        macTips4_desc:'Windows是 Win+L，Mac是 Control+Command+Q（见“常用组合键”里的“Mac锁屏”）。',
        macTips5:'截图',
        macTips5_desc:'Windows是 Win+Shift+S，Mac是 Shift+Command+3/4（见“常用组合键”里的“Mac快速截图”）。',
        macTips6:'首次连接',
        macTips6_desc:'首次连接会弹出串口授权窗口，选择设备并点允许即可；若没有弹窗，多为浏览器版本过旧。',
        connButtonText1:'连接自定义键盘',
        timerConfig:'定时触发配置',
        triggerMode:'触发模式',
        triggerModeManual:'手动触发',
        triggerModeTimer:'定时触发',
        triggerModeBoth:'手动及定时触发',
        hour:'时',
        minute:'分',
        second:'秒',
        keyAllLabel:'3键同时按下时,作为独立按键',
        keyAllTrue:'开',
        keyAllFalse:'关',
        b3key1:'按键1',
        b3key2:'按键2',
        b3key3:'按键3',
        b3keyall:'三键同按',
        deviceTypeLabel:'设备类型',
        deviceVersionLabel:'固件版本',
        backlightTitle:'背光设置',
        backlightMode:'背光模式',
        backlightMode0:'关闭',
        backlightMode1:'常亮',
        backlightMode2:'按键亮',
        backlightMode3:'流水灯',
        backlightMode4:'呼吸灯',
        backlightColor1:'1号灯颜色',
        backlightColor2:'2号灯颜色',
        backlightColor3:'3号灯颜色',
        backlightBrightness:'亮度',
        colorBlue:'蓝',
        colorGreen:'绿',
        colorRed:'红',
        colorYellow:'黄',
        colorCyan:'青',
        colorPurple:'紫',
        colorWhite:'白',
        keyTestLabel:'键盘按键在线测试',
        keyTestUrl:'https://keyboard.bmcx.com/',
        keyTestLabel2:'在线键盘测试',
        keyTestUrl2:'https://www.853295.com/',
        keyTestLabel3:'鼠标按键在线测试',
        keyTestUrl3:'https://cps-check.com/cn/mouse-buttons-test',
        keyTestLabel4:'鼠标测试工具',
        keyTestUrl4:'https://www.mousetester.cn/',
        keyTestPrompt:'点击前往在线键盘测试网站 →',
        c4key1:'按键1',
        c4key2:'按键2',
        c4key3:'按键3',
        c4key4:'按键4',
        ec11Title:'旋钮设置',
        ec11CW:'顺时针旋转',
        ec11CCW:'逆时针旋转',
        ec11Btn:'中键按下',
        ec11FuncKey:'键盘按键',
        ec11FuncMedia:'多媒体键',
        ec11FuncMouse:'鼠标点击',
        ec11FuncFn:'功能键',
        ec11FuncScroll:'鼠标滚轮',
        ec11FuncMix:'组合键',
        ec11ScrollUp:'向上滚轮',
        ec11ScrollDown:'向下滚轮',
        ec11KeyCode:'键码',
        ec11MouseLeft:'左键',
        ec11MouseMiddle:'中键',
        ec11MouseRight:'右键',
        ec11ClickSingle:'单次点击',
        ec11ClickContinuous:'持续点击',
        ec11ClickPress:'按下',
        backlightColor4:'4号灯颜色',
        b6key1:'按键1',
        b6key2:'按键2',
        b6key3:'按键3',
        b6key4:'按键4',
        b6key5:'按键5',
        b6key6:'按键6',
        backlightColor5:'5号灯颜色',
        backlightColor6:'6号灯颜色',
        b4key1:'按键1',
        b4key2:'按键2',
        b4key3:'按键3',
        b4key4:'按键4',
        d2key1:'按键1',
        d2key2:'按键2',
        d2RunModeTitle:'蓝牙模式',
        d2RunMode:'运行模式',
        d2RunModeKeyboard:'键盘模式',
        d2RunModePage:'翻页模式',
        d2PageAction:'翻页动作',
        d2PagePrev:'音量键翻页',
        d2PageNext:'左右滑屏',
        d2PagePlayPause:'上下滑屏',
        d2PageHome:'音乐切换',
        d2PageTableTitle:'翻页动作说明',
        d2TableFirmware:'固件号',
        d2TableFunction:'功能说明',
        d2TableScenario:'使用场景',
        d2Firm1Func:'音量键控制',
        d2Firm1Scenario:'安卓/鸿蒙电子书阅读器小说翻页(部分软件需打开音量键翻页选项)、手机原相机拍照录像',
        d2Firm2Func:'横向左右划动屏幕',
        d2Firm2Scenario:'苹果手机左右小说翻页、iPad横屏时刷短视频',
        d2Firm3Func:'竖向上下滑屏屏幕',
        d2Firm3Scenario:'手机刷短视频(其中一个键快速双击可暂停播放视频，另一个键快速双击可点赞)、iPad横屏时左右小说翻页',
        d2Firm4Func:'音乐播放控制',
        d2Firm4Scenario:'音乐播放器上下切歌，任意键双击暂停播放音乐',
        d2NotesTitle:'使用说明 & 注意事项',
        d2Note1:'苹果用户：需打开<设置-辅助功能-缩放>，若造成屏幕异常，请三指双击屏幕恢复',
        d2Note2:'阅星瞳用户：可扫二维码获取阅星瞳专用模式用法',
        d2Note3:'部分掌阅长续航版本的半封闭阅读器、苹果手机的微信读书、苹果图书：可扫二维码获取备用翻页模式用法',
        changeLog5:'2024.11.2 软件更新为threekey_v7.0.hex 新增长按时按住鼠标设置',
        changeLog4:'2024.7.12 软件更新为threekey_v6.0.hex 新增输入字符串后回车换行设置',
        changeLog3:'2023.6.16 软件更新为threekey_v5.1.hex 修复key2字符串模式记忆bug 修复三键按下部分设置不能记忆',
        changeLog1:'2023.5.4 软件更新为threekey_v5.0.hex 新增设置为鼠标功能',
        changeLog1_1:'如何更新',
        changeLog2:'2023.4.25 软件更新为threekey_v4.1.hex 修复了windows在刚连接键盘就立刻按键的情形 按键失效问题',
        changeLog2_1:'如何更新',
        videoText:'视频介绍',
        keyTest:'在线键盘测试网站',
        mouseTest:'在线鼠标测试网站',
        openSource:'项目软硬件全部开源',
        backToIndex:'回到topyuan.top首页',
        submit:'提交',
        browserErr:'请使用103以上版本Chrome或Edge浏览器,https方式访问此页面!',
        firmwareErr:'当前连接的3键键盘不是最新固件,不支持鼠标设置,请更新!!<br/><br/>新版本:<br/>5.0 新增鼠标设置功能<br/>4.1 修复bug<br/>4.0 新增最多5键的组合键 三键同时按下设置<br/>',
        firmwareErrv5:'当前连接的3键键盘不是最新固件,不支持输入字符串后加回车换行,请更新!!<br/><br/>新版本:<br/>6.0 新增输入字符串后回车换行设置<br/>',
        firmwareErrv6:'当前连接的3键键盘不是最新固件,不支持长按时按住鼠标,请更新!!<br/><br/>新版本:<br/>7.0 新增长按时按住鼠标设置<br/>',
        tip:'提示',
        updateHelp:'更新教程',
        updateNo:'暂不更新,返回',
        redirecting:'正在跳转....请稍后',
        connFirst:'请先连接键盘',
        disconnect:'断开连接',
        success:'设置成功!',
        firmwareErr1:'当前连接的3键键盘不是最新固件,请更新!!<br/><br/>新版本:<br/>5.0 新增鼠标设置功能<br/>4.1 修复bug<br/>4.0 新增最多5键的组合键 三键同时按下设置<br/>',
        updateNo1:'暂不更新,先改键(跳转到旧版改键页)',
        conError1:'端口已占用,连接失败!',
        conError2:'连接失败,原因:',
        conError3:'断开连接失败!请刷新页面!',
        howtoaddress:'https://topyuan.top/3key/howtoupdate',
        shortcutTitle:'快捷键参考',
        shortcutTip:'配置建议',
        shortcutTipDesc:'选择一个按键 → 设置为"组合键"模式 → 在下方配置对应的修饰键(Ctrl/Win/Alt/Shift)+普通键。例如 Ctrl+C：修饰键选"左Ctrl"，按键输入"c"。',
        submitTipTitle:'重要提示',
        submitTipDesc:'设置完成后，请点击页面底部的蓝色"提交"按钮，将当前设置保存到设备中。',
        scGroupEdit:'常用编辑',
        scGroupWin:'窗口与系统',
        scGroupText:'文本与富文本',
        scGroupBrowser:'浏览器',
        scGroupDev:'开发工具',
        scCopy:'复制',
        scPaste:'粘贴',
        scCut:'剪切',
        scUndo:'撤销',
        scRedo:'重做',
        scSelectAll:'全选',
        scSave:'保存',
        scFind:'查找',
        scReplace:'替换',
        scPrint:'打印',
        scSwitchWin:'切换窗口',
        scDesktop:'显示桌面',
        scExplorer:'打开文件管理器',
        scLock:'锁定电脑',
        scSettings:'打开设置',
        scSearch:'搜索',
        scCloseWin:'关闭窗口',
        scFullscreen:'全屏',
        scScreenshot:'截图(全屏)',
        scSnipping:'截图(区域)',
        scBold:'加粗',
        scItalic:'斜体',
        scUnderline:'下划线',
        scSelectWord:'选中单词',
        scHome:'跳到文档开头',
        scEnd:'跳到文档结尾',
        scDelete:'删除',
        scNewTab:'新建标签页',
        scCloseTab:'关闭标签页',
        scSwitchTab:'切换标签页',
        scReopenTab:'恢复关闭标签页',
        scBookmark:'添加书签',
        scRefresh:'刷新',
        scHardRefresh:'强制刷新(清除缓存)',
        scDevTools:'开发者工具',
        scDevTools2:'开发者工具(备选)',
        scDebug:'开始调试',
        scTerminal:'终端',
        scCommandPalette:'命令面板',
        scNewWin:'新建窗口',
        scGroupIDE:'IDE / 编辑器 (Cursor/VS Code)',
        scDeleteLine:'删除行',
        scSelectNext:'选中下一个相同词',
        scSelectAll:'选中所有相同词',
        scMoveLine:'移动行上下',
        scComment:'注释/取消注释',
        scRename:'重命名符号',
        scGlobalSearch:'全局搜索',
        scExplorer:'文件资源管理器',
        scGoToLine:'跳转到行',
        scFormat:'格式化代码',
        scSuggest:'触发建议/补全',
        scQuickFix:'快速修复',
        scToggleSidebar:'切换侧边栏',
        scGoToSymbol:'跳转到符号',
        scGroupAIChat:'AI 对话聊天',
        scAIChatSubmit:'提交 Prompt，发送 AI 生成',
        scAIChatNewline:'仅换行，不发送',
        scAIChatClear:'清空当前对话全部上下文',
        scAIChatUndo:'撤销上一轮 AI 生成代码',
        scAIChatRetry:'重新生成上一次回答（重试）',
        scAIChatStop:'终止 AI 当前正在生成的内容',
        scGroupAICode:'选中代码后 AI 操作',
        scAICodeSidebar:'唤起 AI 侧边栏，解释/修改选中代码',
        scAICodeInline:'Inline AI，代码行内编辑/补全/重构',
        scAICodeSelectBlock:'选中整段函数/代码块',
        scAICodeAccept:'接受 AI 给出的单行代码补全',
        scAICodeReject:'拒绝 AI 补全，回退',
        scAICodeRefactor:'重构选中代码（优化逻辑、修复 bug）',
        scGroupAIFile:'文件与工程全局 AI',
        scAIFileCmdPalette:'打开全局命令面板（所有 AI 功能入口）',
        scAIFileOpen:'打开工程文件',
        scAIFileSearch:'全局工程搜索（可结合 AI 检索代码）',
        scAIFileExplorer:'显示/隐藏左侧工程目录',
        scAIFileTerminal:'调出终端',
        scGroupAIWin:'窗口与会话快捷',
        scAIWinNew:'新建空白对话窗口',
        scAIWinSwitch:'切换多个对话标签',
        scAIWinClose:'关闭当前对话标签',
        scAIWinHistory:'切换历史对话上下文',
        scGroupZoom:'视图缩放',
        scZoomIn:'放大(放大视图/字体)',
        scZoomOut:'缩小(缩小视图/字体)',
        scZoomReset:'重置缩放(恢复100%)',
        scGroupOffice:'办公软件',
        scPasteValue:'粘贴成数值(仅值无格式)',
        scPasteFormat:'粘贴格式',
        scPasteLink:'粘贴为链接',
        scFormulaBar:'显示/隐藏编辑栏',
        scPivotTable:'创建数据透视表',
        scFillDown:'向下填充',
        scGroupNav:'快速导航',
        scGoBack:'后退(返回上一页)',
        scGoForward:'前进(进入下一页)',
        scQuickSave:'另存为',
        scRun:'运行(执行程序/宏)',
        scTaskManager:'打开任务管理器',
        scCycleApps:'循环切换应用程序',
        scGroupZoomShort:'视图缩放',
        scGroupOfficeWord:'Word / WPS文字',
        scWordNewDoc:'新建空白文档',
        scWordOpenDoc:'打开文档',
        scWordSaveAs:'另存为文档',
        scWordFindNext:'查找下一处',
        scWordGoToPage:'定位(跳转到页/书签)',
        scWordInsertLink:'插入超链接',
        scWordInsertPageBreak:'插入分页符',
        scWordSelectPara:'选中整个段落',
        scWord1_5Line:'设置1.5倍行距',
        scWordCenterAlign:'段落居中对齐',
        scWordLeftAlign:'段落左对齐',
        scWordRightAlign:'段落右对齐',
        scWordJustifyAlign:'段落两端对齐',
        scWordBold:'加粗',
        scWordUnderline:'下划线',
        scWordItalic:'斜体',
        scGroupOfficeExcel:'Excel / WPS表格',
        scExcelSumAuto:'自动求和(Alt+=)',
        scExcelFillRight:'向右填充(Ctrl+R)',
        scExcelFillDown:'向下填充(Ctrl+D)',
        scExcelPasteValue:'粘贴成数值(仅值)',
        scExcelPasteFormat:'粘贴格式(格式刷复制)',
        scExcelInsertRow:'插入整行(Ctrl+Shift+=)',
        scExcelDeleteRow:'删除整行(Ctrl+-)',
        scExcelToggleFilter:'开启/关闭筛选',
        scExcelGoToCell:'定位(Goto, F5)',
        scExcelNameBox:'跳转到名称框',
        scExcelTodayDate:'插入当前日期(Ctrl+;)',
        scExcelNowTime:'插入当前时间(Ctrl+Shift+:)',
        scExcelSelectAllRegion:'选中当前数据区域(Ctrl+A)',
        scExcelEditCell:'进入单元格编辑(F2)',
        scExcelSwitchSheet:'切换工作表(Ctrl+PageDown)',
        scExcelFreezePane:'冻结窗格(Alt+W+F)',
        scGroupOfficeCommon:'WPS / Office通用',
        scOfficeNewFile:'新建文件',
        scOfficeOpenFile:'打开文件',
        scOfficeSave:'保存',
        scOfficeSaveAs:'另存为',
        scOfficePrint:'打印',
        scOfficeCloseFile:'关闭当前文件',
        scOfficeUndo:'撤销',
        scOfficeRedo:'重做/恢复',
        scOfficeFind:'查找',
        scOfficeReplace:'替换',
        scOfficeFullScreen:'全屏显示',
        scOfficeZoomPlus:'视图放大',
        scOfficeZoomMinus:'视图缩小',
        scOfficeZoom100:'缩放到100%',
    },
    keyConfig:{
        keyDes1:'普通键',
        keyDes2:'功能键',
        keyDes3:'多媒体键',
        keyDes4:'组合键',
        keyDes5:'字符串',
        keyDes6:'鼠标',
        select:'请选择',
        mix1:'增加功能键',
        mix2:'增加普通键',
        mix3:'删除组合键',
        mix4:'重置组合键',
        mix5:'常用组合键',
        mixtip:'以下为常见组合键,可快速设置,不知道设成啥可以看看,不定期更新',
        mixcommon1:'组合键',
        mixcommon2:'描述',
        mixcommon3:'操作',
        set:'设置',
        inputErr:'输入错误',
        selectErr:'选择错误',
        mixErr:'组合键至少为2键组合!',
        mixErr1:'组合键第',
        mixErr2:'位选择错误',
        mixErr3:'位输入错误',
        textErr:'字符串不能为空',
        textErr1:'字符串输入错误，无此键位',
        setErr:'设置错误',
        delErr:'已无法再删除!',
        mixMaxErr:'最多支持5个按键组合!',
        mixAdd:'请增加功能键或普通键',
        mixMax5:'以上所有按键组合,最多支持5键',
        holdTip:'长按时连续触发',
        holdPressTip:'长按时按住鼠标',
        doubleClick:'双击',
        stringEnter:'输入后按Enter换行',
        move:'移动距离',
        strong:'力度',
        normalKeyTip:'支持数字、英文字母、空格及常用符号',
        normalKeyLowercaseHint:'字母请输入小写（如 c、v）才能生效，大写可能无效',
        mediaKeyTip:'电源、睡眠、屏保等部分按键依赖系统ACPI驱动，可能无法在所有电脑上生效',
        mouses:['左键点击','中键点击','右键点击','随机移动位置','向上移动','向下移动','向左移动','向右移动','向上滚轮','向下滚轮'],
        functionkeys:["左Ctrl", "左Shift", "左Alt", "左Win/Command", "右Ctrl", "右Shift", "右Alt", "右Win/Command", "向上", "向下", "向左", "向右", "Backspace", "Tab", "回车Enter", "ESC", "Insert", "Delete", "Page Up", "Page Down", "Home", "End", "Caps Lock", "Print Screen", "Scroll Lock", "Pause Break", "Num Lock", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "Menu", "/(小键盘)", "*(小键盘)", "-(小键盘)", "+(小键盘)", "Enter(小键盘)", "1(小键盘)", "2(小键盘)", "3(小键盘)", "4(小键盘)", "5(小键盘)", "6(小键盘)", "7(小键盘)", "8(小键盘)", "9(小键盘)", "0(小键盘)", ".(小键盘)"],
        mediakeys:["下一首", "上一首", "停止播放", "播放/暂停", "暂停", "静音", "音量增加", "音量减少","屏幕亮度增加","屏幕亮度减少","打开音乐软件","打开Email软件","打开计算器","打开文件管理器","打开浏览器","浏览器后退","浏览器前进","浏览器刷新","浏览器书签","电源键","睡眠键","录制","快进","回放","屏保"],
        quickSetting:'快速设置',
        quickToggleHint:'点击上方快捷键卡片即可一键配置',
        quickSearchPlaceholder:'搜索快捷键 (如：复制、粘贴、放大、Ctrl+Shift+V...)',
        quickTip1:'💡 小贴士：点击下方卡片即可一键设置该按键为对应快捷键。',
        quickTip2:'找不到想要的快捷键？试试在「组合键」模式里手动设置，或联系客服指导！',
        quickSetSuccess:'已快速设置：',
        quickCategoryAll:'全部',
        quickCategoryEdit:'编辑',
        quickCategorySystem:'系统',
        quickCategoryBrowser:'浏览器',
        quickCategoryOffice:'办公',
        quickCategoryIDE:'开发',
        quickCategoryZoom:'缩放',
        quickCategoryMedia:'多媒体',
        notSet:'未设置',
        videoTutorial:'视频教程'
    }
}


// WEBPACK FOOTER //
// ./src/i18n/zh.js